import type { FC } from 'react';
import Container from 'react-bootstrap/Container';
import Header from '../../Header';
import { AccessCodesTable } from '../../Tables/AccessCodes';

export const TemporaryAccessCode: FC = () => {
  return (
    <Container fluid className="article-page-container p-0">
      <Header title="Access Codes" />
      <AccessCodesTable />
    </Container>
  );
};
